import React, {useState} from 'react';   
import { addToCart,removeFromCart } from '../../redux/slices/CartSlice';
import { addToWishList, loginModalOpen, removeFromWishList } from '../../redux/slices/AuthSlice';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit'; 
import ProductViewModal from './ProductViewModal';
import { Tooltip } from 'react-tooltip';
import YoutubeVideoModal from '../Products/YoutuubeVideoModal';

const  Product = ({product,index}) => {
  const {wishlist_ids,loggedInUser} = useSelector((state:any) => state.auth)
  const {cart} = useSelector((state:any) => state.cart)
 // const {tShirtSettings} = useSelector((state:any) => state.settings)
  const [selectedProduct,setSelectedProduct] = useState('' as any)
  const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
  const [modalShow, setModalShow] = useState(false);
  const lineItemIds =  cart && cart['line_items'] && cart['line_items'].map(a => a.variant_id);
  const [ytModalShow, setYtModalShow] = useState(false);


 
  const handleModalClose = () => {
    setModalShow(false)
  }

  const handleModal= (product) => {
      setModalShow(true)
      setSelectedProduct(product);
  }

  const manageWishList = (product_id,type) => {
    if (loggedInUser === null){
      dispatch(loginModalOpen("User"))
    }
    else{ 
      if(type === "Add"){
        dispatch(addToWishList(product_id))
      }
      if(type === "Remove"){
        dispatch(removeFromWishList(product_id))
      }
    }

  }

  const manageCart = (variant_id,qty,price,actualPrice) => {
    if(lineItemIds && lineItemIds.includes(variant_id)){
      const lineItem = cart['line_items'].filter((line_item) => line_item.variant_id === variant_id ) 
      dispatch(removeFromCart(lineItem[0].id))
    } 
    else{
      dispatch(addToCart({variant_id,qty,price,actualPrice}))
    }    
  } 

  const handleYTModalClose = () => {
    setYtModalShow(false)
  }


  return (
    <>
        <div className="col-6 col-xl-3 col-lg-4 col-md-4 col-sm-6 m-md-b15 m-b30">
            <div className="shop-card style-1">
                {/* <div className={"dz-media tshirtImage " + ('bG'+colorCodes[Math.floor(Math.random() * colorCodes.length)])}>  */}
                <div className={"dz-media tshirtImage "}> 
                    <img src={process.env.REACT_APP_SERVER_URL + (product.variants[0].variant_images[0]?.display_image_url)} alt="product" className='tshirSecondIxmage'/>

                    <div className="shop-meta">
                        <a href="#!"   onClick={() => handleModal(product)} className="btn btn-secondary btn-md btn-rounded" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <i className="fa-solid fa-eye d-md-none d-block"></i>
                            <span className="d-md-block d-none">Quick View</span>
                        </a>
                        <div data-tooltip-id="my-tooltip" data-tooltip-content="Add to wishlist" data-tooltip-place="right" className={"btn btn-primary meta-icon dz-wishicon " + (wishlist_ids.includes(product.id) ? 'active' : "") } onClick={() => manageWishList(product.id,(wishlist_ids.includes(product.id) ? 'Remove' : "Add"))}>
                            <i className="icon feather icon-heart dz-heart" ></i>
                            <i className="icon feather icon-heart-on dz-heart-fill"></i>
                        </div>
                        {product.variants[0].youtube_code && (
                          <div className=" meta-icon yt-video-icon">
                            <a href="#!"   onClick={() => setYtModalShow(true)} className="" data-bs-toggle="modal" data-bs-target="#exampleModal">
                              <i className="icon feather icon-play-circle dz-heart" ></i>
                            </a>
                          </div>
                        )}
                    </div>							
                </div>
                <div className="dz-content">
                    <h5 className="title"><a  href="#!">{product.name} </a></h5>
                    <h5 className="price">₹{Math.round(product.variants[0].price)} <span className='strikedPrice'>₹{Math.round(product.variants[0].actual_price)}</span></h5>
                </div>
                <div className="product-tag">
                <span className="badge ">SKU:  {product.variants[0].sku}</span>
                </div>
            </div>
       
            <Tooltip id="my-tooltip" />
        </div> 
        {selectedProduct  && <ProductViewModal selectedProduct={selectedProduct} modalShow={modalShow} onClose={handleModalClose} wishListData={manageWishList} wishlistIds={wishlist_ids}/>}
        { <YoutubeVideoModal videoId={product.variants[0].youtube_code} modalShow={ytModalShow} onClose={handleYTModalClose} />}
    </> 
  );
}

export default Product;

 
